import React from "react";

function TextElement({ children }) {
  return <p>{children}</p>;
}

export default TextElement;
